// eslint-disable-next-line import/prefer-default-export
export const CREATE_CAMPAIGN_SOURCE_KEY = 'createCampaignSource';
